(function () {
  if (window.WarsunMegaTabsLoaded) return;

  window.WarsunMegaTabsLoaded = true;

  var timers = new WeakMap();

  function getNav(tab) {
    return tab
      ? tab.closest('.mega-menu__nav--tabs')
      : null;
  }

  function setVisualState(tab) {
    var nav = getNav(tab);

    if (!nav) return;

    nav
      .querySelectorAll('[role="tab"]')
      .forEach(function (item) {
        item.classList.remove('is-active');
      });

    tab.classList.add('is-active');
  }


  function syncInitialState(nav) {
    if (!nav) return;

    var selected =
      nav.querySelector(
        '[role="tab"][aria-selected="true"]'
      ) ||
      nav.querySelector(
        '[role="tab"][disabled]'
      ) ||
      nav.querySelector(
        '[role="tab"]'
      );

    if (selected) {
      setVisualState(selected);
    }
  }


  function activateTab(tab) {
    if (
      !tab ||
      tab.getAttribute('role') !== 'tab'
    ) {
      return;
    }

    var nav = getNav(tab);

    if (!nav) return;


    /* Already selected by the current Athens component */
    if (
      tab.getAttribute('aria-selected') === 'true'
    ) {
      setVisualState(tab);
      return;
    }


    /* Legacy Athens active state */
    if (tab.disabled) {
      setVisualState(tab);
      return;
    }


    if (timers.get(nav)) {
      clearTimeout(
        timers.get(nav)
      );
    }


    timers.set(
      nav,

      setTimeout(function () {

        /*
          Let the native tabs component do the actual
          panel switching. We only trigger the click
          and maintain our WARSUN visual state.
        */

        tab.click();

        setVisualState(tab);

      }, 50)
    );
  }


  /*
    Initialize all mega-menu tab groups.
  */

  function initializeTabs(root) {
    var scope = root || document;

    scope
      .querySelectorAll(
        '.mega-menu__nav--tabs'
      )
      .forEach(function (nav) {
        syncInitialState(nav);
      });
  }


  document.addEventListener(
    'pointerover',

    function (event) {

      var tab =
        event.target.closest(
          '.mega-menu__nav--tabs [role="tab"]'
        );

      if (!tab) return;


      var oldTab =
        event.relatedTarget &&
        event.relatedTarget.closest
          ? event.relatedTarget.closest(
              '.mega-menu__nav--tabs [role="tab"]'
            )
          : null;


      if (oldTab === tab) return;

      activateTab(tab);

    }
  );


  document.addEventListener(
    'focusin',

    function (event) {

      var tab =
        event.target.closest(
          '.mega-menu__nav--tabs [role="tab"]'
        );

      if (!tab) return;

      activateTab(tab);

    }
  );


  /*
    Shopify editor can re-render the header,
    so initialize again when sections reload.
  */

  document.addEventListener(
    'shopify:section:load',

    function (event) {
      initializeTabs(event.target);
    }
  );


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',

      function () {
        initializeTabs(document);
      }
    );

  } else {

    initializeTabs(document);

  }

})();